export default {
  open: true,
  width: window.innerWidth,
  menuList: {}
};
